module.exports = __webpack_public_path__ + "static/media/levelOneBackground@2x.bc068885.jpg";